import { Component } from '@angular/core';

@Component({
  selector: 'app-superadmin-footer',
  imports: [],
  templateUrl: './superadmin-footer.component.html',
  styleUrl: './superadmin-footer.component.scss'
})
export class SuperadminFooterComponent {

}
